module.exports = __webpack_public_path__ + "img/GameConsole-game.86e13e1c.png";